export default "__VITE_ASSET__nEUs_5si__"